import xs from "xstream"
import {div, br, label, input, button, h4, ul, li, h5, span} from "@cycle/dom"
import * as R from "ramda"

import {LoginForm} from "../../interface"

export const view = (loginForm$, topText$, msg$, isBusy$) => {
	return xs.combine(loginForm$, topText$, msg$, isBusy$)
		.map(([{loginId,password}, topTexts, msg, isBusy]:[LoginForm, string[], string, boolean]) => {
			const disabled = !(loginId && password ) || isBusy
			return div([
				div(".mt-3",[
					div(".mb-3",[
						label(".form-label",{attrs: {for:'loginId'}},["会員番号"]),
						div(".col-sm-4",[
							input("#loginId.form-control", {attrs: {type:"text", placeholder:"半角数字7桁", name:'loginId', maxlength: 7}, props:{value: loginId}})
						])
					]),
					div(".mb-3",[
						label(".form-label",{attrs: {for:'password'}},["パスワード"]),
						div(".col-sm-4",[
							input("#password.form-control", {attrs: {type:"text", placeholder:"半角英数字", name:'password'}, props:{value: password}})
						]),
            (msg !== null)
              ? div(".errMsg.mt-1",["※",msg])
              : null
              ,
            ]),
					div(".mb-3",[
						div(".d-grid.col-md-4",[
							button("#btnLogin.btn.btn-primary", {attrs: {type: "button"}, props:{disabled: disabled}},["ログイン"])
						])
					]),
					div(".form-group", [
						div(".col-sm-offset-2.col-sm-10",[
							div(".passwordLink", [
								"※パスワードを忘れた方は",span(".link", ["こちらから"])
							])
						])
					]),
					// div(".topMsg.mt-2",[
					// 	h5(["【WEB会員証でできること】"]),
					// 	ul(R.map(t => li([t]), topTexts || [])),
					// ]),
				])
			])
		})
}
